var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tips paperIndex-info"},[_c('p',{staticClass:"tips-title infos"},[_vm._v("温馨提示")]),_vm._l((_vm.tips),function(item,index){return _c('div',{key:index,staticClass:"hint"},[_vm._v(_vm._s(item))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }